module.exports = __webpack_public_path__ + "static/img/instant-refund.04790035.webp";